var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './disclaimer.component.less';
import { isArray, isEmpty, isNumber, isString, isUndefined } from 'lodash';
import { Stratus } from '@stratusjs/runtime/stratus';
import { isJSON, safeUniqueId } from '@stratusjs/core/misc';
import moment from 'moment';
const packageName = 'idx';
const moduleName = 'disclaimer';
const componentName = 'disclaimer';
const localDistStyle = `${Stratus.BaseUrl}${Stratus.DeploymentPath}@stratusjs/${packageName}/dist/${packageName}.bundle.min.css`;
Stratus.Components.IdxDisclaimer = {
    bindings: {
        elementId: '@',
        initNow: '=',
        service: '@',
        type: '@',
        hideOnDuplicate: '@',
        modificationTimestamp: '=',
    },
    controller($attrs, $sce, $scope, Idx) {
        $scope.uid = safeUniqueId(packageName, moduleName, componentName);
        Stratus.Instances[$scope.uid] = $scope;
        $scope.elementId = $attrs.elementId || $scope.uid;
        $scope.initialized = false;
        $scope.onWatchers = [];
        $scope.service = $attrs.service && isJSON($attrs.service) ? JSON.parse($attrs.service) : [];
        $scope.idxService = [];
        $scope.type = $attrs.type ? JSON.parse($attrs.type) : 'Property';
        $scope.alwaysShow = typeof $attrs.hideOnDuplicate === 'undefined';
        Stratus.Internals.CssLoader(localDistStyle).then();
        let mlsVariables;
        const init = () => __awaiter(this, void 0, void 0, function* () {
            Idx.registerDisclaimerInstance($scope.elementId, $scope);
            Idx.on('Idx', 'sessionInit', () => {
                if (!$scope.initialized) {
                    $scope.processMLSDisclaimer();
                    $scope.initialized = true;
                }
                Idx.on('Idx', 'fetchTimeUpdate', (_scope, _serviceId, _modelName, _fetchTime) => {
                    $scope.processMLSDisclaimer(true);
                });
            });
            Idx.on('Idx', 'sessionRefresh', () => {
                $scope.processMLSDisclaimer(true);
                $scope.initialized = true;
            });
            $scope.$watch('$ctrl.hideOnDuplicate', (hideOnDuplicate) => {
                if (typeof $attrs.hideOnDuplicate !== 'undefined') {
                    $scope.alwaysShow = false;
                    if (hideOnDuplicate !== true) {
                        $scope.hideOnDuplicate =
                            $attrs.hideOnDuplicate ? (isString($attrs.hideOnDuplicate) && isJSON($attrs.hideOnDuplicate) ?
                                JSON.parse($attrs.hideOnDuplicate) : false) : false;
                    }
                    else {
                        $scope.hideOnDuplicate = hideOnDuplicate || false;
                    }
                    $scope.$applyAsync(() => {
                        $scope.hideMe = false;
                        if ($scope.hideOnDuplicate) {
                            const instances = Idx.getDisclaimerInstance();
                            Object.keys(instances).forEach((elementId) => {
                                if (elementId !== $scope.elementId &&
                                    instances[elementId].alwaysShow === true &&
                                    (instances[elementId].modificationTimestamp === null ||
                                        isUndefined(instances[elementId].modificationTimestamp))) {
                                    $scope.hideMe = true;
                                }
                            });
                        }
                    });
                }
            });
            Idx.emit('init', $scope);
        });
        this.$onInit = () => {
            $scope.Idx = Idx;
            let initNow = true;
            if (Object.prototype.hasOwnProperty.call($attrs.$attr, 'initNow')) {
                initNow = isJSON($attrs.initNow) ? JSON.parse($attrs.initNow) : false;
            }
            const stopWatchingService = $scope.$watch('$ctrl.service', (service) => {
                $scope.service = isString(service) && isJSON(service) ? JSON.parse(service) : [];
                $scope.processMLSDisclaimer(true);
                $scope.$applyAsync();
                stopWatchingService();
            });
            if (initNow) {
                init().then();
                return;
            }
            const stopWatchingInitNow = $scope.$watch('$ctrl.initNow', (initNowCtrl) => {
                if (initNowCtrl !== true) {
                    return;
                }
                if (!$scope.initialized) {
                    init().then();
                }
                stopWatchingInitNow();
            });
        };
        $scope.getMLSVariables = (reset) => {
            if (!mlsVariables || Object.keys(mlsVariables).length === 0 || reset) {
                mlsVariables = [];
                let mlsServicesRequested = null;
                if ($scope.service &&
                    (isNumber($scope.service) ||
                        !isEmpty($scope.service))) {
                    if (!isArray($scope.service)) {
                        $scope.service = [$scope.service];
                    }
                    mlsServicesRequested = $scope.service;
                }
                Idx.getMLSVariables(mlsServicesRequested).forEach((service) => {
                    mlsVariables[service.id] = service;
                });
            }
            return Object.values(mlsVariables);
        };
        $scope.processMLSDisclaimer = (reset) => {
            const services = $scope.getMLSVariables(reset);
            $scope.idxService = [];
            let disclaimerComplete = '';
            services.forEach(service => {
                let singleDisclaimer = '';
                if (service.fetchTime[$scope.type]) {
                    singleDisclaimer += `Last checked ${moment(service.fetchTime[$scope.type]).format('M/D/YY h:mm a')}. `;
                }
                else if (Idx.getLastSessionTime()) {
                    singleDisclaimer += `Last checked ${moment(Idx.getLastSessionTime()).format('M/D/YY')}. `;
                }
                if ($scope.modificationTimestamp) {
                    singleDisclaimer += `Listing last updated ${moment($scope.modificationTimestamp).format('M/D/YY h:mm a')}. `;
                }
                singleDisclaimer += service.disclaimer;
                if (disclaimerComplete) {
                    disclaimerComplete += '<br>';
                }
                disclaimerComplete += singleDisclaimer;
                const cleanService = service;
                cleanService.disclaimerString = singleDisclaimer;
                cleanService.disclaimerHTML = $sce.trustAsHtml(singleDisclaimer);
                $scope.idxService.push(cleanService);
            });
        };
        $scope.on = (emitterName, callback) => Idx.on($scope.elementId, emitterName, callback);
        $scope.remove = () => {
            $scope.onWatchers.forEach(killOnWatcher => killOnWatcher());
        };
    },
    template: '<div id="{{::elementId}}" class="disclaimer-outer-container" data-ng-cloak data-ng-show="idxService.length > 0 && !hideMe" role="contentinfo" aria-label="IDX Disclaimers">' +
        '<div class="disclaimer-container" data-ng-repeat="service in idxService" data-ng-bind-html="service.disclaimerHTML"></div>' +
        '<div class="mls-logos-section" aria-label="MLS Logos">' +
        '<div class="mls-logos-container" data-ng-repeat="service in idxService">' +
        '<img class="mls-service-logo" alt="{{service.name}} MLS Brand Logo" data-ng-show="service.logo.default"  aria-label="{{service.name}}" data-ng-src="{{service.logo.medium || service.logo.default}}">' +
        '<img class="mls-service-logo" alt="{{service.name}} MLS supplementary Logo" data-ng-if="service.mandatoryLogo && service.mandatoryLogo.length > 0" data-ng-repeat="mandatoryLogo in service.mandatoryLogo"  aria-label="{{service.name}} supplementary" data-ng-src="{{mandatoryLogo}}">' +
        '</div>' +
        '</div>' +
        '</div>'
};

//# sourceMappingURL=disclaimer.component.js.map
